export const messages = {
  requiredText: 'Bu dəyər boş olmamalıdır.',
  successText: 'Məlumatlar yadda saxlandı.',
  errorText: 'Xəta baş verdi!',
  noWhitespaceMessage: 'Boşluq olmamalıdır.',
  warningText: 'Məlumatlar boş olmamalıdır.',
  notDefined: '- Daxil edilməmişdir.',
  fileSizeError: 'Faylın həcmi 5 MB-dən çox olmamalıdır!',
  emailFormat:
    'Bu dəyər düzgün e-poçt ünvanı deyil. Nümunə: devsales@prospectsmb.com',
  numberFormat: 'Bu dəyər yalnız 0-1,000,000 arası ədəd ola bilər.',
  percentageFormat: 'Bu dəyər yalnız 0-100 arası ədəd ola bilər.',
  urlFormat: 'Bu dəyər düzgün ünvan deyil. Nümunə: prospect.az',
  urlFormatExe: 'Bu dəyər düzgün ünvan deyil. ',
  wrongInformation: 'Yanlış məlumat.',
  passwordRepeatError: 'Şifrənin təkrarı düzgün deyil.',
  maxtextLimitMessage: limitSize => `${limitSize} simvoldan çox olmamalıdır.`,
  mintextLimitMessage: limitSize => `${limitSize} simvoldan az olmamalıdır.`,
};
